import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  auditLogRead,
  clientRead,
  configRead,
  kycRead,
  localizationRead,
  messageRead,
  paymentRead,
  roleRead,
  staffRead
} from './app.constants';
import { AppLayoutComponent } from './core/app-layout/app-layout.component';
import { AuthGuard } from './core/auth/guards/auth-guard.service';
import { PrivilegeGuard } from './core/auth/guards/privilege-guard.service';
import { Error404Component } from './shared/components/error-404/error-404.component';

const childrenRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        m => m.DashboardModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'clients',
    loadChildren: () =>
      import('./modules/clients/clients.module').then(m => m.ClientsModule),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: clientRead }
  },
  {
    path: 'messages',
    loadChildren: () =>
      import('./modules/messages/messages.module').then(m => m.MessagesModule),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: messageRead }
  },
  {
    path: 'kyc-requests',
    loadChildren: () =>
      import('./modules/kyc-requests/kyc-requests.module').then(
        m => m.KycRequestsModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: kycRead }
  },
  // {
  //   path: 'reporting',
  //   loadChildren: () =>
  //     import('./modules/reporting/reporting.module').then(
  //       m => m.ReportingModule
  //     ),
  //   canActivate: [AuthGuard],
  //   canLoad: [PrivilegeGuard],
  //   data: { expectedRole: roleStaff }
  // },
  {
    path: 'cumulative-reports',
    loadChildren: () =>
      import(
        './modules/reporting/cumulative-reports/comulative-reports.module'
      ).then(m => m.ComulativeReportsModule),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: configRead }
  },
  {
    path: 'bank-transfer',
    loadChildren: () =>
      import('./modules/bank-transfer/bank-transfer.module').then(
        m => m.BankTransferModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: paymentRead }
  },
  // {
  //   path: 'crypto-coin-pro-transaction',
  //   loadChildren: () =>
  //     import('./modules/bank-transfer/crypto-coin-pro-transactions/crypto-coin-pro.module').then(
  //       m => m.CryptoCointProTransfersModule
  //     ),
  //    canActivate: [AuthGuard],
  //    canLoad: [PrivilegeGuard],
  //    data: { expectedRole: paymentRead }
  //  },

  {
    path: 'audit-logs',
    loadChildren: () =>
      import('./modules/audit-logs/audit-logs.module').then(
        m => m.AuditLogsModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: auditLogRead }
  },
  {
    path: 'localization',
    loadChildren: () =>
      import('./modules/localization/localization.module').then(
        m => m.LocalizationModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: localizationRead }
  },
  {
    path: 'properties',
    loadChildren: () =>
      import('./modules/properties/properties.module').then(
        m => m.PropertiesModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: configRead }
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/user-profile/user-profile.module').then(
        m => m.UserProfileModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./modules/user-managment/users/users.module').then(
        m => m.UsersModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: staffRead }
  },
  {
    path: 'roles',
    loadChildren: () =>
      import('./modules/user-managment/roles/roles.module').then(
        m => m.RolesModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: roleRead }
  },
  {
    path: 'collateralized-loans',
    loadChildren: () =>
      import('./modules/loans/request-loans/request-loans.module').then(
        m => m.RequestLoansModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: paymentRead }
  },
  {
    path: 'active-services',
    loadChildren: () =>
      import('./modules/loans/active-loans/active-loans.module').then(
        m => m.ActiveLoansModule
      ),
    canActivate: [AuthGuard],
    canLoad: [PrivilegeGuard],
    data: { expectedRole: paymentRead }
  },
  {
    path: '**',
    component: Error404Component
  }
];

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./modules/forgot-password/forgot-password.module').then(
        m => m.ForgotPasswordModule
      )
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: childrenRoutes
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'corrected',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
